module.exports = __webpack_public_path__ + "static/img/banner02.ab33070.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page_index/banner02.jpg
// module id = UNCf
// module chunks = 1